<script setup>
  import { ref, onBeforeMount, computed } from "vue";
  import { useCompanyStore } from "@/stores/company";
import { useUiStore } from "@/stores/ui";
import { useAgentsStore } from "@/stores/agents";
  const emit = defineEmits(['refresh']);
  const company_id = useCompanyStore().companyId;
  const uiStore = useUiStore();
  const agentsStore = useAgentsStore();
  const getModalInfo = computed(()=> uiStore.modalData);
  const getModalAction = computed(()=> uiStore.modalAction);
  let promptId = ref(null);
  let agentId = ref(null);
  let isSubmitted = ref(false);

  const resetStoreData = () =>{
    uiStore.setModalState(false);
    uiStore.setModalData({});
    uiStore.setModalAction(null);
  };

  const onSubmit = () => {
    isSubmitted.value = true;

    agentsStore.assignPrompt({prompt_id : promptId.value , company_id : company_id, agent_id : agentId.value})
    .then(() => {
      resetStoreData();
      emit('refresh');
    })
    .catch(() => {
      isSubmitted.value = false;
    });

  };

  onBeforeMount(()=>{
    if(getModalInfo.value && getModalAction.value == 'assign_prompt'){
      promptId.value = getModalInfo.value.id;
      agentId.value = getModalInfo.value.agent_id;
    }
  });
</script>
<template>
  <DModal v-if="getModalAction === 'assign_prompt'" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]" :dialog_classes="[]">
    <template #title> Assign Prompt </template>

    <template #body>

      <div class="delete-text mb-3">
        <span>Are you sure you want to <b>"Assign"</b> this prompt ?</span>
      </div>

    </template>

    <template #footer>
      <div class="w-full">
        <div class="seperator text-center"></div>
        <div class="flex mt-20 justify-center">
          <button @click="resetStoreData" type="button" class="btn btn-primary add-button mr-30">Cancel</button>
          <button :disabled="isSubmitted" @click="onSubmit" type="button" class="btn btn-secondary cancel-button" >
            Assign <span v-if="isSubmitted" class="spinner-sm" role="status" aria-hidden="true"></span>
          </button>
        </div>
      </div>
    </template>
  </DModal>
</template>
  
